import { County } from 'src/shared/models/county';
import { ExtraOption } from 'src/shared/models/formSettingRespons';
import { GridSortDirection } from '@mui/x-data-grid';
import { MemberStatusTabKeysEnum } from 'src/shared/models/enums/memberStatusTabKeys.enum';
import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from 'src/shared/models/enums/gridFilterConfig';
import { MemberProfileData } from './member';
import { MemberTabItem, memberTabs } from './memberTabs';
import { TitlePickerItem } from './titlePickerItem';

export type MemberSearchFormState = {
  pageIndex: number;
  pageSize: number;
  sortCol: string;
  sortDir: GridSortDirection;

  status?: MemberTabItem[] | undefined;
  selectionId?: number | null;
  selectionName?: string | null | undefined;
  selectionInfo?: string | null | undefined;
  groupName?: string | null;
  searchString?: string | null | undefined;
  districtIds?: [] | string | null | undefined;
  associationIds?: [] | string | null | undefined;
  countyCode?: County[] | undefined;
  municipalityCode?: County[] | undefined;
  postCode?: string | null | undefined;
  excludedProfileItemIds?: MemberProfileData[] | undefined;
  profileItemIds?: MemberProfileData[] | undefined;

  admDateStart?: string;
  admDateEnd?: string;

  resDateStart?: string;
  resDateEnd?: string;

  dueDateStart?: string;
  dueDateEnd?: string;

  payDateStart?: string;
  payDateEnd?: string;

  birthDateStart?: string;
  birthDateEnd?: string;

  hasMobilePhone?: string;
  hasEmailAddress?: string;
  hasNewspaper?: string;
  isMainMember?: string;
  isFamilyMember?: string;
  otherContact?: string;

  resCause?: ExtraOption;
  sex?: ExtraOption;

  titleIds?: TitlePickerItem[] | undefined;
  includeResignedTitles?: string;
};

/**
 * Returns default values for `MemberSearchFormState`.
 */
export const getDefaultMemberSearchFormState = (): Partial<MemberSearchFormState> => ({
  pageIndex: DEFAULT_PAGE_INDEX, // Default starting page index
  pageSize: DEFAULT_PAGE_SIZE, // Default page size
  sortCol: 'memberNr', // Default column to sort by
  sortDir: 'desc', // Default sort direction (descending, highest member number first)
  status: memberTabs.filter((x) => x.key === MemberStatusTabKeysEnum.Paid || x.key === MemberStatusTabKeysEnum.NotPaid),
});

export default getDefaultMemberSearchFormState;
